import axios from 'axios';

/**
 * 轮播图服务
 */
const bannerService = {
  /**
   * 获取所有活跃的轮播图
   * @returns {Promise} 返回活跃轮播图列表
   */
  getActiveBanners() {
    return axios.get('/api/banners');
  },
  
  /**
   * 管理员获取所有轮播图
   * @returns {Promise} 返回所有轮播图列表
   */
  getAllBanners() {
    return axios.get('/api/admin/banners');
  },
  
  /**
   * 获取单个轮播图详情
   * @param {number} id 轮播图ID
   * @returns {Promise} 返回轮播图详情
   */
  getBannerById(id) {
    return axios.get(`/api/admin/banners/${id}`);
  },
  
  /**
   * 创建轮播图
   * @param {Object} bannerData 轮播图数据
   * @returns {Promise} 返回创建结果
   */
  createBanner(bannerData) {
    return axios.post('/api/admin/banners', bannerData);
  },
  
  /**
   * 更新轮播图
   * @param {number} id 轮播图ID
   * @param {Object} bannerData 轮播图数据
   * @returns {Promise} 返回更新结果
   */
  updateBanner(id, bannerData) {
    return axios.put(`/api/admin/banners/${id}`, bannerData);
  },
  
  /**
   * 删除轮播图
   * @param {number} id 轮播图ID
   * @returns {Promise} 返回删除结果
   */
  deleteBanner(id) {
    return axios.delete(`/api/admin/banners/${id}`);
  }
};

export default bannerService; 